import { useCallback, useMemo } from 'react';
import { useWeb3React } from '@web3-react/core';
import { config } from '../../../config/config';
import { EnabledChains, TimeConversions } from '../../../config/constants';
// import { NO_LOCK_MANDATORY_PERIOD } from '../../../config/constants';
import useLiquidityPools from './useLiquidityPools';
// import useTokenDetails from '../useTokenDetails';
import { UserLockedDeposit } from './useUserLockedDeposits';

const useMockUserLockedDeposits = () => {
    const { chainId } = useWeb3React();
    const { liquidityPools } = useLiquidityPools();
    // const { decimals } = useTokenDetails(
    //     config.addresses[chainId as EnabledChains[number]]?.collateral
    // );

    const userLockedDeposits = useMemo<UserLockedDeposit[]>(() => {
        if (!liquidityPools) return [];

        const now = Math.floor(Date.now() / 1000);

        const blueChipPool = liquidityPools.find(
            (p) =>
                p.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.blueChip?.toLowerCase()
        );
        const altCoinPool = liquidityPools.find(
            (p) =>
                p.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.altCoin?.toLowerCase()
        );
        const degenPool = liquidityPools.find(
            (p) =>
                p.poolId.toLowerCase() ===
                config.addresses[
                    chainId as EnabledChains[number]
                ]?.liquidityPools.degen?.toLowerCase()
        );

        const deposits: UserLockedDeposit[] = [];

        if (blueChipPool) {
            deposits.push(
                {
                    depositTimestamp: now - TimeConversions.SECONDS_PER_DAY * 45,
                    unlockTime: now - TimeConversions.SECONDS_PER_DAY * 15,
                    liquidityPool: blueChipPool,
                    lockUpType: { lockUpId: 0, duration: 30, feeMultiplier: 1.25 },
                    depositAmount: '1500.00',
                    txHash: '0x1a2b3c4d5e6f7890abcdef1234567890abcdef1234567890abcdef1234567890',
                },
                {
                    depositTimestamp: now - TimeConversions.SECONDS_PER_DAY * 20,
                    unlockTime: now + TimeConversions.SECONDS_PER_DAY * 10,
                    liquidityPool: blueChipPool,
                    lockUpType: { lockUpId: 1, duration: 60, feeMultiplier: 1.5 },
                    depositAmount: '2500.00',
                    txHash: '0x2b3c4d5e6f7890abcdef1234567890abcdef1234567890abcdef1234567890ab',
                }
            );
        }

        if (altCoinPool) {
            deposits.push({
                depositTimestamp: now - TimeConversions.SECONDS_PER_DAY * 10,
                unlockTime: now + TimeConversions.SECONDS_PER_DAY * 20,
                liquidityPool: altCoinPool,
                lockUpType: { lockUpId: 0, duration: 30, feeMultiplier: 1.25 },
                depositAmount: '800.00',
                txHash: '0x3c4d5e6f7890abcdef1234567890abcdef1234567890abcdef1234567890abcd',
            });
        }

        if (degenPool) {
            deposits.push(
                {
                    depositTimestamp: now - TimeConversions.SECONDS_PER_DAY * 60,
                    unlockTime: now - TimeConversions.SECONDS_PER_DAY * 30,
                    liquidityPool: degenPool,
                    lockUpType: { lockUpId: 1, duration: 60, feeMultiplier: 1.5 },
                    depositAmount: '500.00',
                    txHash: '0x4d5e6f7890abcdef1234567890abcdef1234567890abcdef1234567890abcdef',
                },
                {
                    depositTimestamp: now - TimeConversions.SECONDS_PER_DAY * 5,
                    unlockTime: now + TimeConversions.SECONDS_PER_DAY * 25,
                    liquidityPool: degenPool,
                    lockUpType: { lockUpId: 2, duration: 90, feeMultiplier: 2.0 },
                    depositAmount: '300.00',
                    txHash: '0x5e6f7890abcdef1234567890abcdef1234567890abcdef1234567890abcdef12',
                }
            );
        }

        return deposits.sort((a, b) => b.depositTimestamp - a.depositTimestamp);
    }, [liquidityPools, chainId]);

    const updateUserLockedDeposits = useCallback(() => {}, []);

    return {
        userLockedDeposits,
        isLoading: false,
        error: undefined,
        updateUserLockedDeposits,
    };
};

export default useMockUserLockedDeposits;
